import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../../utils/Api";
import { Typography, Flex, Row, Col, Button, notification, Modal } from "antd";
import Layout from "../../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../../utils/CustomComponents";
import { EditFilled, PlusCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Reception from "./Reception";
const { Text } = Typography;

const ReceptionList = () => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [receptionList, setReceptionList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [plant, setPlant] = useState(null);
	const [plantList, setPlantList] = useState([]);
	const [modalReceptionOpen, setModalReceptionOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const receptionId = useRef(null);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "# Ticket",
			dataIndex: "ticket",
			key: "ticket",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Quantity",
			dataIndex: "quantity",
			key: "quantity",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Supplier",
			dataIndex: "supplier",
			key: "supplier",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "# Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Registration Date",
			dataIndex: "registrationDate",
			key: "registrationDate",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Received Date",
			dataIndex: "receivedDate",
			key: "receivedDate",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Batcher",
			dataIndex: "batcher",
			key: "batcher",
			render: (value) => <Text>{value}</Text>,
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => {
				return (
					<Row>
						<Col>
							{(localStorage.getItem("email") === "eliud@gmail.com" ||
								localStorage.getItem("email") === "bpa@57concrete.com" ||
								localStorage.getItem("email") === "aca@57concrete.com" ||
								localStorage.getItem("email") === "ji@57concrete.com" ||
								localStorage.getItem("email") === "jp@57concrete.com" ||
								localStorage.getItem("email") === "mv@57concrete.com" ||
								localStorage.getItem("email") === "pc@57concrete.com" ||
								localStorage.getItem("email") === "jc@57concrete.com" ||
								localStorage.getItem("email") === "gg@57xgroup.com" ||
								localStorage.getItem("email") === "ec@57concrete.com") && (
								<Button
									icon={
										<EditFilled
											onClick={() => {
												receptionId.current = record.id;
												setModalReceptionOpen(true);
												setIsEdit(true);
											}}
										/>
									}
								/>
							)}
						</Col>
					</Row>
				);
			},
		},
	];

	useEffect(() => {
		if (startDate && endDate && plant !== null) {
			getReceptionList();
		}
	}, [startDate, endDate, plant, refresh]);

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setPlantList(list);
				if (localStorage.getItem("role") === "Batch") {
					setPlant(localStorage.getItem("plant"));
				} else {
					setPlant(list.find((p) => p.label === "Mission").value);
				}
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const getReceptionList = async () => {
		setLoadingTable(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/reception/get/list/dates?startDate=${start}&endDate=${end}&plant=${plant}`;

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						ticket: item.ticket,
						material: item.material.material,
						quantity: `${item.quantity} ${item.material.inventoryUnitOfMeasurement}`,
						supplier: item.supplier.name,
						truck: item.truck,
						registrationDate: dayjs(item.createdAt).format("MM/DD/YYYY HH:mm"),
						receivedDate: dayjs(item.receivedDate).format("MM/DD/YYYY HH:mm"),
						batcher: item.batcher ? item.batcher.name : "N/A",
					});
				});
				setReceptionList(list);
				setLoading(false);
				setLoadingTable(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable
					columns={columns}
					loading={loadingTable || loading}
					isScroll={false}
					data={receptionList}
				/>
			</Flex>
		);
	};

	const onChangePlant = (value) => {
		setPlant(value);
	};

	const onRangeChange = useCallback(
		(dates) => {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		},
		[setStartDate, setEndDate],
	);

	const addNewReception = () => {
		setIsEdit(false);
		setModalReceptionOpen(true);
	};

	const RenderFilters = () => {
		return (
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<CustomSearch
						startDate={startDate}
						endDate={endDate}
						onRangeChange={onRangeChange}
						dateFormat={"MM/DD/YYYY"}
						loading={loading}
						allowClearPicker={false}
						labelPicker={"Plant"}
						optionsPicker={plantList}
						pickerWidth={"300px"}
						pickerValue={plant}
						onChangePicker={onChangePlant}
						disabledPicker={localStorage.getItem("role") === "Batch"}
					/>
				</Col>
				<Col span={24}>
					<Button
						type="primary"
						htmlType="button"
						size="large"
						icon={<PlusCircleOutlined />}
						onClick={addNewReception}
					>
						Add Reception
					</Button>
				</Col>
			</Row>
		);
	};

	const onCompleteReception = useCallback(() => {
		receptionId.current = null;
		setModalReceptionOpen(false);
		setRefresh((prev) => !prev);
	}, []);

	const ModalViewData = () => {
		return (
			<Modal
				title={`${isEdit ? "Edit" : "Add"} Reception`}
				open={modalReceptionOpen}
				onCancel={() => setModalReceptionOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Reception
					onComplete={onCompleteReception}
					isEdit={isEdit}
					receptionId={receptionId.current}
				/>
			</Modal>
		);
	};

	return (
		<Layout title="Inventory Capture" description="Inventory" type="large">
			<Flex vertical gap={"large"}>
				<RenderFilters />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
			<ModalViewData />
		</Layout>
	);
};

export default ReceptionList;
